import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/design-system.css'; // Import design system
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ProfileProvider } from './context/ProfileContext';
import { SubscriptionProvider } from './context/SubscriptionContext';
import ErrorBoundary from './components/common/ErrorBoundary';

// Suppress WebSocket connection errors from webpack-dev-server (harmless HMR warnings)
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error;
  console.error = (...args) => {
    if (args[0]?.includes?.('WebSocket') && args[0]?.includes?.('ws://localhost:3000/ws')) {
      // Suppress webpack-dev-server WebSocket connection errors (harmless)
      return;
    }
    originalError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <ProfileProvider>
          <SubscriptionProvider>
            <App />
          </SubscriptionProvider>
        </ProfileProvider>
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
